class QuickView extends HTMLElement {
  constructor() {
    super();
    this.onOpenQuickView = this.onOpenQuickView.bind(this);
    this.onCloseQuickView = this.onCloseQuickView.bind(this);
  }

  onOpenQuickView(event) {
    const productElement = this.querySelector("main-product");
    productElement.renderProduct(event.detail.handle);
    this.modal?.show();
  }

  onCloseQuickView(event) {
    this.modal?.hide();
  }

  connectedCallback() {
    this.modal = this.querySelector("#quick-view");
    document.addEventListener("quick-view:open", this.onOpenQuickView);
    document.addEventListener("quick-view:close", this.onCloseQuickView);
    document.addEventListener("cart-item:added", this.onCloseQuickView);
  }

  disconnectedCallback() {
    document.removeEventListener("quick-view:open", this.onOpenQuickView);
    document.removeEventListener("quick-view:close", this.onCloseQuickView);
    document.removeEventListener("cart-item:added", this.onCloseQuickView);
  }
}

customElements.define("quick-view", QuickView);
